import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	clearAttendanceList,
	loadAttendanceByUserId,
} from "../../redux/rtk/features/attendance/attendanceSlice";
import PageTitle from "../page-header/PageHeader";

import { useParams } from "react-router-dom";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import AttendanceCalendar from "./AttendanceCalender";


const UserAttendance = () => {
	const { list, loading } = useSelector((state) => state.attendance);
	const { id } = useParams("id");
	// console.log("id", id);
	// console.log("Redux lists state Attendance", list);


	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadAttendanceByUserId(id));

		return () => {
			dispatch(clearAttendanceList());
		};
	}, [id]);

	return (
		<UserPrivateComponent permission='readSingle-attendance'>
			<div>
				<PageTitle title='Back' />
				<AttendanceCalendar />
				{/* {
				!loading ? <CustomTable list={list} loading={loading} /> : <Loader
				/>
				} */}
			</div>
		</UserPrivateComponent>
	);
};

export default UserAttendance;
